import Query from '../../components/Report';

const query = new Query('discover-collected-pages');

export default query;
